/**
 * GOFOR360 — Cart Drawer v3 (Premium + AOV Max)
 * Features: tiered rewards, personalized recs, animated reward milestones,
 * delivery estimate, payment icons, sticky CTA, announcement bar
 */
(function () {
  'use strict';

  const CFG = {
    tiers: [
      // Same rewards + order as the live theme (gifts are added by EG Auto Add rules).
      { at: 30, label: 'spedizione gratuita', done: 'Spedizione gratuita sbloccata' },
      // €60: guida "Il Piano Semplice" (€0, digitale) aggiunta dal drawer stesso → syncGuideGift()
      { at: 60, label: 'la guida in regalo', short: 'guida in regalo', done: 'Guida "Il Piano Semplice" in regalo' },
      { at: 90, label: 'il consiglio su misura con Carlo', done: 'Consiglio con Carlo sbloccato' },
      { at: 150, label: 'MAG5+ 150g gratuito', done: 'MAG5+ 150g gratuito sbloccato' }
    ],
    guideGift: { variantId: 53526368190801, tag: 'GUIDA 60', at: 60 },
    // Variants whose subscription comes with the Multivitamine gift (EG "Sub gift")
    subGiftVariants: [52728605442385, 52814701756753],
    clubDiscountPct: 20,
    maxUpsells: 4,
    cartSelectors: [
      'a[href="/cart"]', '.cart-link', '.header__cart',
      '[data-cart-toggle]', '.cart-icon-bubble', '.js-cart-icon'
    ],
    goalNames: {
      RS: 'Relax e Sonno', EF: 'Energia e Sport', DS: 'Difese Immunitarie',
      MP: 'Metabolismo e Cuore', DD: 'Digestione e Detox', PC: 'Pelle e Capelli',
      UR: 'Benessere urinario e drenaggio'
    },
    needNames: {
      str: 'stress', ene: 'energia', son: 'sonno', dif: 'difese immunitarie',
      pel: 'pelle', pes: 'peso', dre: 'drenaggio', gon: 'gonfiore',
      art: 'articolazioni', cap: 'capelli', col: 'colesterolo', men: 'menopausa',
      reg: 'regolarità', rec: 'recupero', inf: 'infiammazione', det: 'detox',
      oss: 'ossa', mem: 'memoria', spo: 'sport', fer: 'fermenti',
      cis: 'cistite', cir: 'circolazione', pro: 'prostata', tes: 'testosterone',
      fro: 'ferro', vis: 'vista', met: 'metabolismo', cuo: 'cuore',
      ome: 'omega-3', car: 'cartilagini', cre: 'creatina', las: 'lassativo',
      ant: 'antiossidante', ref: 'reflusso', int: 'intestino'
    },
    // Delivery estimate: business days to add (24-48h = 1-2 business days)
    deliveryMin: 1,
    deliveryMax: 2,
    // Cutoff for same-day shipping (24h format)
    shippingCutoffHour: 14,
    shippingCutoffMinute: 30
  };

  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const drawer = $('#gc-drawer');
  const overlay = $('#gc-overlay');
  if (!drawer) return;

  const el = {
    body: $('[data-gc-body]', drawer),
    count: $('[data-gc-count]', drawer),
    items: $('[data-gc-items]', drawer),
    fill: $('[data-gc-fill]', drawer),
    rewardsMsg: $('[data-gc-rewards-msg]', drawer),
    upsell: $('[data-gc-upsell]', drawer),
    upsellList: $('[data-gc-upsell-list]', drawer),
    footer: $('[data-gc-footer]', drawer),
    summary: $('[data-gc-summary]', drawer),
    subtotal: $('[data-gc-subtotal]', drawer),
    footerSubtotal: $('[data-gc-footer-subtotal]', drawer),
    ctaPrice: $('[data-gc-cta-price]', drawer),
    shipping: $('[data-gc-shipping]', drawer),
    toast: $('#gc-toast'),
    // v3 elements
    announce: $('[data-gc-announce]', drawer),
    announceText: $('[data-gc-announce-text]', drawer),
    deliveryDate: $('[data-gc-delivery-date]', drawer),
    savingsRow: $('[data-gc-savings-row]', drawer),
    savings: $('[data-gc-savings]', drawer),
    quizDiscountRow: $('[data-gc-quiz-discount-row]', drawer),
    quizDiscountAmount: $('[data-gc-quiz-discount]', drawer),
    // Reward elements
    allUnlocked: $('[data-gc-all-unlocked]', drawer),
    quizCta: $('[data-gc-quiz-cta]', drawer),
    subscribe: $('[data-gc-subscribe]', drawer)
  };

  let state = { cart: null, prevTier: -1, productCache: {}, recoMap: null, open: false, busy: false, quizDiscount: 0 };

  /* ── HELPERS ── */
  const money = c => '€' + (c / 100).toFixed(2).replace('.', ',');
  const euros = cart => cart.total_price / 100;
  // Gift tiers (2-3) are measured like the EG Auto Add rules: pre-discount subtotal of
  // paid lines (gift lines at €0 excluded). Shipping (tier 1) uses the discounted total.
  // Same "cart value" EG Auto Add uses for its cartValue gifts (Carlo ≥90, MAG5+ 150g ≥150):
  // prices before automatic discounts, subscription lines at their subscription price
  // (verified live 24/10 with 506 support), gift lines excluded.
  const isGiftLine = i => i.final_line_price <= 0 || !!(i.properties && i.properties._Gifted);
  const lineGiftValue = i => i.original_line_price;
  const giftBase = cart => Math.max(cart.total_price, (cart.items || []).reduce((s, i) => s + (isGiftLine(i) ? 0 : lineGiftValue(i)), 0)) / 100;
  const getTier = t => { for (let i = CFG.tiers.length - 1; i >= 0; i--) if (t >= CFG.tiers[i].at) return i + 1; return 0; };
  // Subscription-only carts ship free (Subify delivery profile): treat tier 1 as unlocked.
  const allSubs = cart => { const paid = (cart.items || []).filter(i => !isGiftLine(i)); return paid.length > 0 && paid.every(i => !!i.selling_plan_allocation); };
  const shipValue = cart => (allSubs(cart) ? Math.max(euros(cart), CFG.tiers[0].at) : euros(cart));
  const tierOf = cart => (shipValue(cart) >= CFG.tiers[0].at ? Math.max(1, getTier(giftBase(cart))) : 0);
  const TOP = () => CFG.tiers.length;
  const getPct = t => Math.min((t / CFG.tiers[CFG.tiers.length - 1].at) * 100, 100);
  const esc = s => { const d = document.createElement('div'); d.textContent = s; return d.innerHTML; };
  const imgUrl = (u, sz) => u ? u.replace(/(\.[^.]+)$/, `_${sz}$1`).replace('http:', 'https:') : '';

  /* ── DELIVERY ESTIMATE ── */
  function getDeliveryEstimate() {
    const now = new Date();
    const dayNames = ['domenica', 'lunedì', 'martedì', 'mercoledì', 'giovedì', 'venerdì', 'sabato'];
    const monthNames = ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'];

    function addBusinessDays(date, days) {
      const result = new Date(date);
      let added = 0;
      while (added < days) {
        result.setDate(result.getDate() + 1);
        const dow = result.getDay();
        if (dow !== 0 && dow !== 6) added++;
      }
      return result;
    }

    // If before cutoff on a business day, ship today; otherwise next business day
    let shipDate = new Date(now);
    const isWeekend = now.getDay() === 0 || now.getDay() === 6;
    const pastCutoff = now.getHours() > CFG.shippingCutoffHour ||
      (now.getHours() === CFG.shippingCutoffHour && now.getMinutes() >= CFG.shippingCutoffMinute);
    if (isWeekend || pastCutoff) {
      shipDate = addBusinessDays(now, 1);
    }

    const minDate = addBusinessDays(shipDate, CFG.deliveryMin);
    const maxDate = addBusinessDays(shipDate, CFG.deliveryMax);

    const fmtShort = d => `${d.getDate()} ${monthNames[d.getMonth()]}`;

    if (minDate.getDate() === maxDate.getDate() && minDate.getMonth() === maxDate.getMonth()) {
      return fmtShort(minDate);
    }
    return `${fmtShort(minDate)} - ${fmtShort(maxDate)}`;
  }

  /* ── ANNOUNCEMENT BAR ── */
  function updateAnnouncement() {
    if (!el.announceText) return;
    const now = new Date();
    const hour = now.getHours();
    const min = now.getMinutes();
    const cutoffH = CFG.shippingCutoffHour;
    const cutoffM = CFG.shippingCutoffMinute;
    const dow = now.getDay();
    const isWeekend = dow === 0 || dow === 6;
    const pastCutoff = hour > cutoffH || (hour === cutoffH && min >= cutoffM);

    if (isWeekend) {
      // Find next Monday
      const daysToMon = dow === 0 ? 1 : 2;
      el.announceText.innerHTML = `Ordina ora, spedizione <strong>luned\u00ec</strong> alle 14:30`;
    } else if (!pastCutoff) {
      // Show time remaining until 14:30
      const remH = cutoffH - hour - (min > cutoffM ? 1 : 0);
      const remM = (cutoffM - min + 60) % 60;
      if (remH > 0) {
        el.announceText.innerHTML = `Ordina entro <strong>${remH}h ${remM > 0 ? remM + 'min' : ''}</strong> per spedizione oggi`;
      } else {
        el.announceText.innerHTML = `Ordina entro <strong>${remM} min</strong> per spedizione oggi`;
      }
    } else {
      // Past cutoff on weekday
      if (dow === 5) {
        el.announceText.innerHTML = `Ordina ora, spedizione <strong>luned\u00ec</strong>`;
      } else {
        el.announceText.textContent = 'Ordina ora, spedizione domani mattina';
      }
    }
  }

  /* ── RECOMMENDATION ENGINE ── */
  function loadRecoMap() {
    const script = document.getElementById('gc-reco-map');
    if (!script) return {};
    try { return JSON.parse(script.textContent); } catch (e) { return {}; }
  }

  function loadSellingPlanMap() {
    const script = document.getElementById('gc-selling-plans');
    if (!script) return {};
    try { return JSON.parse(script.textContent); } catch (e) { return {}; }
  }

  /* Products that should NEVER be suggested as recommendations.
     They stay in the reco map (so their goal/need is read when in cart),
     but are filtered out from the suggestion scoring. Typical reason:
     they're already offered as a tier reward gift. */
  const EXCLUDE_FROM_RECS = new Set([
    'mag',                       // Mag +  (offered as MAG5+ tier 2 gift)
    'mag-5',                     // MAG 5+ original
    'mag-5-bisglicinato-150g',   // MAG 5+ 150g format (same product line)
  ]);

  /* Products whose gf_goal metafield generically says "digestione, detox e vie
     urinarie" but that are actually about the urinary tract. We override their
     goal client-side to UR so headings and reco stop suggesting "digestione".
     Add handles here as new urinary products ship. */
  const URINARY_HANDLES = new Set([
    'cistoril',
    'gofor360-prostata',
  ]);
  function overrideGoalsForHandle(handle, goals) {
    if (URINARY_HANDLES.has(handle)) return ['UR'];
    return goals;
  }

  /* Kit → component handles: if ANY component is already in cart, skip the kit */
  const KIT_COMPONENTS = {
    'kit-cambio-di-stagione-donna': ['gofor360-capelli-e-unghie','mag-5'],
    'kit-cambio-di-stagione-uomo': ['mag-5','gofor360-capelli-e-barba'],
    'kit-estate': ['k-mag-3','beta-c'],
    'kit-forma': ['gofor360-detox','gofor360-fat-drena-plus'],
    'kit-gonfiore': ['finoforce','gofor360-digovix'],
    'kit-lady-menopausa': ['gofor360-lady','mag-5'],
    'kit-performance-testosterone': ['gofor360-vigor','zinco'],
    'kit-sonno': ['mag-5','gofor360-relax'],
    'kit-stress-plus-ashwaganda-ksm-66': ['mag-5','ashwa-b'],
    'pacchetto-benessere-intestinale': ['gofor360-fermenti-lattici','gofor360-lassativo'],
    'pacchetto-dimagrimento-intenso': ['gofor360-tisana-drenante','gofor360-termogenico','integratore-brucia-grassi-forte-per-dimagrire'],
    'pacchetto-drenante': ['gofor360-tisana-drenante','gofor360-drena-strong'],
    'pacchetto-sollievo': ['gofor360-cartilagini','mag'],
    'pacchetto-stress': ['mag-5','gofor360-vitamina-b'],
  };

  function getPersonalizedRecs(cart, limit) {
    const map = state.recoMap;
    if (!map || !Object.keys(map).length) return [];

    const cartIds = new Set(cart.items.map(i => String(i.product_id)));
    // Build set of handles already in cart (for kit overlap check)
    const cartHandles = new Set();
    cart.items.forEach(item => {
      const meta = map[String(item.product_id)];
      if (meta) cartHandles.add(meta.h);
    });
    const cartGoals = new Set();
    const cartNeeds = new Set();

    cart.items.forEach(item => {
      const pid = String(item.product_id);
      const meta = map[pid];
      if (meta) {
        const effectiveGoals = overrideGoalsForHandle(meta.h, meta.g);
        effectiveGoals.forEach(g => cartGoals.add(g));
        meta.n.forEach(n => cartNeeds.add(n));
      }
    });

    const scores = {};

    for (const [pid, meta] of Object.entries(map)) {
      if (cartIds.has(pid)) continue;

      // Skip handles that should never be suggested (e.g. tier reward gifts)
      if (EXCLUDE_FROM_RECS.has(meta.h)) continue;

      // Skip kits whose components are already in cart
      const kitComps = KIT_COMPONENTS[meta.h];
      if (kitComps && kitComps.some(h => cartHandles.has(h))) continue;

      let score = 0;
      const reasons = [];

      const effectiveGoals = overrideGoalsForHandle(meta.h, meta.g);
      const sharedGoals = effectiveGoals.filter(g => cartGoals.has(g));
      const sharedNeeds = meta.n.filter(n => cartNeeds.has(n));
      const uniqueNeeds = meta.n.filter(n => !cartNeeds.has(n));

      if (sharedGoals.length > 0 && uniqueNeeds.length > 0) {
        score += 50 * sharedGoals.length;
        const needName = CFG.needNames[uniqueNeeds[0]] || uniqueNeeds[0];
        reasons.push({ type: 'complementary', text: `Complementare per ${needName}` });
      }

      if (sharedNeeds.length > 0) {
        score += 25 * sharedNeeds.length;
        const needName = CFG.needNames[sharedNeeds[0]] || sharedNeeds[0];
        reasons.push({ type: 'shared_need', text: `Potenzia ${needName}` });
      }

      if (sharedGoals.length > 0) {
        score += 15 * sharedGoals.length;
        if (!reasons.length) {
          const goalName = CFG.goalNames[sharedGoals[0]] || sharedGoals[0];
          reasons.push({ type: 'same_goal', text: `Stesso obiettivo: ${goalName}` });
        }
      }

      if (!sharedGoals.length && meta.n.some(n => cartNeeds.has(n))) {
        score += 20;
        const crossNeed = meta.n.find(n => cartNeeds.has(n));
        const needName = CFG.needNames[crossNeed] || crossNeed;
        reasons.push({ type: 'cross_goal', text: `Aiuta anche con ${needName}` });
      }

      if (meta.bs) score += 10;
      if (meta.p >= 15 && meta.p <= 35) score += 5;

      if (score > 0) {
        scores[pid] = {
          id: pid, handle: meta.h, price: meta.p, score,
          reason: reasons[0] || { type: 'popular', text: 'Popolare' },
          bestseller: !!meta.bs
        };
      }
    }

    return Object.values(scores).sort((a, b) => b.score - a.score).slice(0, limit || CFG.maxUpsells);
  }

  function getUpsellHeading(cart) {
    const map = state.recoMap;
    const goalCounts = {};
    cart.items.forEach(item => {
      const meta = map[String(item.product_id)];
      if (meta) {
        const effectiveGoals = overrideGoalsForHandle(meta.h, meta.g);
        effectiveGoals.forEach(g => { goalCounts[g] = (goalCounts[g] || 0) + 1; });
      }
    });

    if (!Object.keys(goalCounts).length) return { heading: 'Completa la tua routine', sub: '' };

    const topGoal = Object.entries(goalCounts).sort((a, b) => b[1] - a[1])[0]?.[0];
    const headings = {
      RS: { heading: 'Completa il tuo rituale relax', sub: 'Scelti per il tuo percorso di relax e sonno' },
      EF: { heading: 'Potenzia la tua energia', sub: 'Complementi ideali per la tua routine sportiva' },
      DS: { heading: 'Rafforza le tue difese', sub: 'Abbinamenti consigliati per il tuo sistema immunitario' },
      MP: { heading: 'Ottimizza il tuo metabolismo', sub: 'Prodotti complementari per i tuoi obiettivi' },
      DD: { heading: 'Migliora la tua digestione', sub: 'Complementi ideali per il tuo benessere intestinale' },
      PC: { heading: 'Cura la tua bellezza', sub: 'Prodotti complementari per pelle e capelli' },
      UR: { heading: 'Sostieni le vie urinarie', sub: 'Complementi ideali per drenaggio e benessere urinario' }
    };

    return headings[topGoal] || { heading: 'Scelti per te', sub: 'In base ai prodotti nel tuo carrello' };
  }

  /* ── PRODUCT FETCHER ──
     Three layers of cache: in-memory (state.productCache), sessionStorage (per tab),
     and an in-flight Promise map to coalesce concurrent fetches for the same handle. */
  const _inFlightProducts = {};
  function _readSessionCache(handle) {
    try {
      const raw = sessionStorage.getItem('gc:p:' + handle);
      if (!raw) return null;
      const obj = JSON.parse(raw);
      // Refresh after 1h to avoid stale prices
      if (Date.now() - obj.t > 3600 * 1000) return null;
      return obj.p;
    } catch(e) { return null; }
  }
  function _writeSessionCache(handle, product) {
    try { sessionStorage.setItem('gc:p:' + handle, JSON.stringify({ t: Date.now(), p: product })); } catch(e) {}
  }

  async function fetchProduct(handle, retries = 2) {
    if (state.productCache[handle]) return state.productCache[handle];
    const fromSession = _readSessionCache(handle);
    if (fromSession) { state.productCache[handle] = fromSession; return fromSession; }
    // Coalesce concurrent fetches for the same handle
    if (_inFlightProducts[handle]) return _inFlightProducts[handle];

    _inFlightProducts[handle] = (async () => {
      for (let i = 0; i <= retries; i++) {
        try {
          const r = await fetch(`/products/${handle}.json`);
          if (r.ok) {
            const data = await r.json();
            state.productCache[handle] = data.product;
            _writeSessionCache(handle, data.product);
            return data.product;
          }
          if (r.status === 429 && i < retries) {
            await new Promise(ok => setTimeout(ok, 500 * (i + 1)));
            continue;
          }
        } catch (e) {
          if (i < retries) { await new Promise(ok => setTimeout(ok, 300)); continue; }
        }
        break;
      }
      return null;
    })();
    try {
      const result = await _inFlightProducts[handle];
      delete _inFlightProducts[handle];
      return result;
    } catch(e) {
      delete _inFlightProducts[handle];
      return null;
    }
  }

  /* Background prefetch: when the user has a cart with goal/need tagging, warm
     the product cache for the top-scoring upsell candidates. Runs once at init
     so the first drawer open renders upsells without waiting on network. */
  function prefetchTopUpsells() {
    try {
      if (!state.recoMap || !state.cart) return;
      // Compute a cart-blind heuristic ranking: bestsellers in 15-35€ band.
      const candidates = Object.values(state.recoMap)
        .filter(m => m.bs && m.p >= 15 && m.p <= 35)
        .sort((a, b) => Math.abs(25 - a.p) - Math.abs(25 - b.p))
        .slice(0, 8);
      candidates.forEach(meta => {
        if (!state.productCache[meta.h] && !_readSessionCache(meta.h)) {
          // Fire and forget — populates cache for first render
          fetchProduct(meta.h).catch(() => {});
        }
      });
    } catch(e) { /* non-fatal */ }
  }

  /* ── CART API ── */
  const api = {
    _recheckTimers: [],
    /** Re-fetch cart multiple times to catch external app changes (e.g. EG Auto Add to Cart gift products) */
    deferredRecheck() {
      api._recheckTimers.forEach(t => clearTimeout(t));
      api._recheckTimers = [];
      [1200, 3000, 6000].forEach(delay => {
        api._recheckTimers.push(setTimeout(async () => {
          if (state.busy) return;
          try {
            const r = await fetch('/cart.js', { credentials: 'same-origin' });
            const c = await r.json();
            if (c.item_count !== state.cart.item_count || c.total_price !== state.cart.total_price) {
              state.cart = c; render();
            }
          } catch (e) { /* silent */ }
        }, delay));
      });
    },
    async get() { const r = await fetch('/cart.js', { credentials: 'same-origin' }); state.cart = await r.json(); return state.cart; },
    async change(line, qty) {
      if (state.busy) return; state.busy = true; drawer.classList.add('is-loading');
      try {
        const r = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line, quantity: qty }), credentials: 'same-origin' });
        const data = await r.json();
        if (data.status === 422 || data.message || data.description) {
          toast(api._italianError(data.description || data.message || ''));
          await api.get(); render();
        } else {
          state.cart = data; render();
        }
      } finally { state.busy = false; drawer.classList.remove('is-loading'); api.deferredRecheck(); }
    },
    async add(id, qty = 1, props = {}) {
      // Note: we do NOT block on state.busy here. Shopify accepts concurrent /cart/add.js
      // calls safely, and dropping rapid clicks would leave the user with "Aggiunto ✓"
      // feedback on buttons whose products never actually made it into the cart.
      // state.busy is reserved for serializing qty changes on the same line item.
      open();
      try {
        const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id, quantity: qty, properties: props }] }), credentials: 'same-origin' });
        if (!r.ok) {
          const err = await r.json().catch(() => ({}));
          toast(api._italianError(err.description || err.message || ''));
        }
        await api.get(); render();
      } finally { api.deferredRecheck(); }
    },
    _italianError(msg) {
      const m = (msg || '').toLowerCase();
      if (m.includes('cart') || m.includes('quantity') || m.includes('limit') || m.includes('only') || m.includes('add'))
        return 'Puoi aggiungere un solo consiglio su misura nel carrello';
      if (m.includes('sold out') || m.includes('available'))
        return 'Prodotto non disponibile';
      return msg || 'Si è verificato un errore';
    },
  };

  /* ── OPEN / CLOSE ── */
  let _scrollY = 0;
  function open() {
    state.open = true; drawer.classList.add('is-open'); overlay.classList.add('is-active');
    try { ensureExpressCheckout(); } catch (e) {}
    // Lock body scroll — iOS-safe: position:fixed + save scroll position
    _scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${_scrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.overflow = 'hidden';
    document.body.classList.add('gc-drawer-open');
    const f = $$('a[href],button:not([disabled]),input,[tabindex]', drawer);
    if (f[0]) f[0].focus();
  }
  function close() {
    state.open = false; drawer.classList.remove('is-open'); overlay.classList.remove('is-active');
    // Restore body scroll
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.overflow = '';
    document.body.classList.remove('gc-drawer-open');
    window.scrollTo(0, _scrollY);
  }

  /* ── RENDER ── */
  function render() {
    const cart = state.cart, total = giftBase(cart), shipTotal = shipValue(cart), t = tierOf(cart), p = Math.min(getPct(total), 100);

    el.count.textContent = cart.item_count;
    updateCartBubble(cart.item_count);

    el.fill.style.width = p + '%';

    // Update tier cards (Cymbiotika-style)
    $$('.gc-rewards__tier', drawer).forEach((card, i) => {
      const tierIdx = i + 1;
      const ctaEl = card.querySelector('.gc-rewards__tier-cta');
      if (t >= tierIdx) {
        card.setAttribute('data-unlocked', '');
        card.removeAttribute('data-next');
        const numEl = card.querySelector('.gc-rewards__tier-num');
        if (numEl && !numEl.querySelector('svg')) {
          numEl.innerHTML = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M20 6L9 17l-5-5"/></svg>';
        }
        if (ctaEl) ctaEl.textContent = 'Sbloccato ✓';
      } else {
        card.removeAttribute('data-unlocked');
        // Cleanup leftover confetti canvas from a previous unlock animation.
        // Prevents emoji confetti remaining stuck on the card after user empties cart.
        card.querySelectorAll('.gc-confetti-canvas').forEach(c => c.remove());
        const rem = Math.max(1, Math.ceil(CFG.tiers[i].at - (i === 0 ? shipTotal : total)));
        if (t === i) {
          card.setAttribute('data-next', '');
          if (ctaEl) ctaEl.textContent = `+€${rem}`;
        } else {
          card.removeAttribute('data-next');
          if (ctaEl) ctaEl.textContent = `Mancano €${rem}`;
        }
        const numEl = card.querySelector('.gc-rewards__tier-num');
        if (numEl && numEl.querySelector('svg')) {
          numEl.textContent = String(tierIdx);
        }
      }
    });

    if (el.rewardsMsg) {
      if (t >= TOP()) {
        el.rewardsMsg.className = 'gc-rewards__msg gc-rewards__msg--done';
        el.rewardsMsg.innerHTML = 'Tutti i premi sbloccati';
      } else {
        const next = CFG.tiers[t], rem = Math.max(1, Math.ceil(next.at - (t === 0 ? shipTotal : total)));
        el.rewardsMsg.className = 'gc-rewards__msg';
        el.rewardsMsg.innerHTML = `Aggiungi <strong>&euro;${rem}</strong> per ${next.label}`;
      }
    }

    // Tier unlock celebration with confetti
    if (t > state.prevTier && state.prevTier >= 0) {
      toast(CFG.tiers[t - 1].done);
      const tierCard = $(`.gc-rewards__tier[data-tier="${t}"]`, drawer);
      if (tierCard) {
        tierCard.setAttribute('data-just-unlocked', '');
        setTimeout(() => tierCard.removeAttribute('data-just-unlocked'), 800);
        spawnConfetti(tierCard);
      }
    }
    state.prevTier = t;

    // Show/hide all-unlocked celebration
    if (el.allUnlocked) {
      el.allUnlocked.style.display = t >= TOP() ? '' : 'none';
    }

    renderItems(cart);

    // Show/hide sections based on cart state
    const hasItems = cart.item_count > 0;
    el.footer.style.display = hasItems ? '' : 'none';
    if (el.summary) el.summary.style.display = hasItems ? '' : 'none';
    if (el.quizCta) el.quizCta.style.display = hasItems ? '' : 'none';
    if (el.subscribe) el.subscribe.style.display = hasItems ? '' : 'none';

    // Subtotal & CTA (adjusted for quiz discount)
    const qd = state.quizDiscount || 0;
    const adjustedTotal = cart.total_price - qd;
    if (el.subtotal) el.subtotal.textContent = money(adjustedTotal);
    if (el.footerSubtotal) el.footerSubtotal.textContent = money(adjustedTotal);
    el.ctaPrice.textContent = money(adjustedTotal);
    el.shipping.textContent = t >= 1 ? 'Gratuita' : 'Calcolata al checkout';

    // Quiz discount row
    if (el.quizDiscountRow && el.quizDiscountAmount) {
      if (qd > 0) {
        el.quizDiscountRow.style.display = '';
        el.quizDiscountAmount.textContent = '-' + money(qd);
      } else {
        el.quizDiscountRow.style.display = 'none';
      }
    }

    // Checkout link — always /checkout. Quiz discount is handled by quiz-v2 page.
    const checkoutLink = $('[data-gc-checkout]', drawer);
    if (checkoutLink) checkoutLink.href = '/checkout';

    // Savings
    if (el.savingsRow && el.savings) {
      const savingsAmount = cart.original_total_price - cart.total_price + qd;
      if (savingsAmount > 0) {
        el.savingsRow.style.display = '';
        el.savings.textContent = '-' + money(savingsAmount);
      } else {
        el.savingsRow.style.display = 'none';
      }
    }

    // Delivery estimate
    if (el.deliveryDate) el.deliveryDate.textContent = getDeliveryEstimate();

    // Announcement
    updateAnnouncement();

    // Debounce upsell rebuild: rapid bursts of add-to-cart clicks would otherwise
    // destroy and recreate the upsell cards between clicks, detaching button refs
    // and dropping the user's clicks. Wait 800ms of quiet before regenerating.
    renderUpsellsDebounced(cart, total, t);
    updateSubscribeVisibility();
    syncGuideGift(cart, t);
  }

  /* ── Express checkout (Shop Pay / Apple Pay / Google Pay / PayPal) ──
     Hyperspeed defers Shopify's PaymentButton script until the first user action,
     but Shopify's own starter calls Shopify.PaymentButton.init() at DOMContentLoaded,
     fails (not defined yet) and never retries. We retry it here once the deferred
     script is available. init() is Shopify's own and turns itself into a no-op after
     the first call, so calling it again is harmless. */
  let _expressPoll = null;
  function ensureExpressCheckout(maxWaitMs) {
    if (!document.querySelector('[data-gc-express] shopify-accelerated-checkout-cart')) return;
    if (window.customElements && customElements.get('shopify-accelerated-checkout-cart')) return;
    if (_expressPoll) return;
    const start = Date.now(), limit = maxWaitMs || 15000;
    const tick = () => {
      if (window.customElements && customElements.get('shopify-accelerated-checkout-cart')) { _expressPoll = null; return; }
      const pb = window.Shopify && window.Shopify.PaymentButton;
      if (pb && typeof pb.init === 'function') {
        try { pb.init(); } catch (e) {}
        _expressPoll = null; return;
      }
      if (Date.now() - start < limit) _expressPoll = setTimeout(tick, 400); else _expressPoll = null;
    };
    tick();
  }
  // First user action = Hyperspeed releases the deferred scripts: prepare the buttons
  // before the drawer is even opened.
  ['pointerdown', 'touchstart', 'keydown', 'scroll'].forEach((ev) => {
    window.addEventListener(ev, () => { try { ensureExpressCheckout(); } catch (e) {} }, { once: true, passive: true, capture: true });
  });

  /* ── Header cart icon: always show the item count (also on mobile, also when the
     page was loaded with an empty cart and the theme didn't render the bubble). ── */
  function updateCartBubble(count) {
    const n = Number(count) || 0;
    const icons = $$('#cart-icon-bubble, .header__icon--cart');
    icons.forEach(icon => {
      let b = icon.querySelector('.cart-count-bubble');
      if (!n) { if (b) b.remove(); return; }
      if (!b) { b = document.createElement('div'); b.className = 'cart-count-bubble font-bold gc-count-bubble'; icon.appendChild(b); }
      b.classList.add('gc-count-bubble');
      b.innerHTML = `<span aria-hidden="true">${n > 99 ? '99+' : n}</span><span class="visually-hidden">${n} ${n === 1 ? 'articolo' : 'articoli'}</span>`;
    });
    $$('.cart-count,[data-cart-count-bubble],.js-cart-count').forEach(e => { e.textContent = n; });
  }

  /* ── €60 TIER: guida "Il Piano Semplice" in regalo ──
     Prodotto digitale a €0: nessuno sconto da configurare, lo aggiunge/toglie il drawer.
     Tocca solo la riga con la proprietà _Gifted che mette lui; se la guida è già nel
     carrello per altri motivi (bundle PDP) non la duplica e non la rimuove. */
  let _guideSyncAt = 0, _guideSyncing = false;
  function syncGuideGift(cart, t) {
    const g = CFG.guideGift;
    if (!g || !cart || state.busy || _guideSyncing) return;
    if (Date.now() - _guideSyncAt < 1500) return;
    const items = cart.items || [];
    const hasGuide = items.some(i => Number(i.variant_id) === g.variantId);
    const ours = items.find(i => Number(i.variant_id) === g.variantId && i.properties && i.properties._Gifted === g.tag);
    const paidCount = items.filter(i => !isGiftLine(i)).length;
    const want = t >= 2 && paidCount > 0;
    let req = null;
    if (want && !hasGuide) {
      req = fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: g.variantId, quantity: 1, properties: { _Gifted: g.tag } }] }) });
    } else if (!want && ours) {
      req = fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: ours.key, quantity: 0 }) });
    }
    if (!req) return;
    _guideSyncing = true; _guideSyncAt = Date.now();
    req.then(() => api.get()).then(() => render()).catch(() => {}).finally(() => { _guideSyncing = false; });
  }

  // Leading-edge debounce: first render runs immediately (so user sees upsells
  // without waiting), subsequent rapid renders are coalesced and the trailing
  // one runs after 250ms quiet. This keeps upsell buttons attached during a
  // burst of clicks but doesn't delay the first paint.
  let _upsellRenderTimer = null;
  let _upsellBurstActive = false;
  function renderUpsellsDebounced(cart, total, t) {
    if (!_upsellBurstActive) {
      _upsellBurstActive = true;
      renderUpsells(cart, total, t);
      _upsellRenderTimer = setTimeout(() => { _upsellBurstActive = false; }, 250);
    } else {
      if (_upsellRenderTimer) clearTimeout(_upsellRenderTimer);
      _upsellRenderTimer = setTimeout(() => {
        _upsellBurstActive = false;
        renderUpsells(cart, total, t);
      }, 250);
    }
  }

  function renderItems(cart) {
    if (!cart.item_count) {
      el.items.innerHTML = '<div class="gc-empty"><p class="gc-empty__title">Il tuo carrello è vuoto</p><p class="gc-empty__sub">Scopri i nostri integratori naturali</p><a href="/collections/all" class="gc-empty__link">Esplora i prodotti →</a></div>';
      if (el.upsell) el.upsell.style.display = 'none';
      return;
    }
    if (el.upsell) el.upsell.style.display = '';

    // Quiz discount (unified): entrambe le sorgenti (cart drawer quiz + quiz V2 page)
    // taggano con `_quiz_discount: "20"`. Lo sconto -20% viene applicato al checkout tramite
    // codice sconto auto-applicato (GF360QUIZR20X9K) quando ci sono >=2 quiz items.
    // `_quiz_v2_source: "1"` distingue l'origine per il tracking (non influenza lo sconto).
    const quizItems = cart.items.filter(it => it.properties && it.properties._quiz_discount === '20');
    const quizActive = quizItems.length >= 2;

    let quizDiscountTotal = 0;

    // AOV-style: clone pre-rendered Liquid templates by variant_id instead of
    // building HTML from JSON. Falls back to JS template literal if the variant
    // wasn't on the page at render time (rare — products added since pageload).
    const frag = document.createDocumentFragment();
    cart.items.forEach((item, i) => {
      const tpl = document.querySelector(`[data-gc-line-tpl="${item.variant_id}"]`);
      let node;
      const isQuizItem = item.properties && item.properties._quiz_discount === '20';
      const itemDiscPct = (isQuizItem && quizActive) ? 20 : 0;
      if (tpl && tpl.content && tpl.content.firstElementChild) {
        node = tpl.content.firstElementChild.cloneNode(true);
        // Patch the dynamic bits the template can't know about: line index, qty,
        // line price total (price × qty), discount badges, subscription tag.
        node.setAttribute('data-line', i + 1);
        const qtyEl = node.querySelector('[data-gc-qty]');
        if (qtyEl) qtyEl.textContent = item.quantity;
        const priceEl = node.querySelector('[data-gc-tpl-price]');
        if (priceEl) {
          let html;
          if (itemDiscPct > 0) {
            const discAmount = Math.round(item.final_line_price * itemDiscPct / 100);
            quizDiscountTotal += discAmount;
            const discPrice = item.final_line_price - discAmount;
            html = `<s class="gc-item__price--was">${money(item.final_line_price)}</s> ${money(discPrice)}<span class="gc-item__quiz-badge">-${itemDiscPct}%</span>`;
          } else if (item.original_line_price > item.final_line_price) {
            html = `<s class="gc-item__price--was">${money(item.original_line_price)}</s> ${money(item.final_line_price)}`;
          } else {
            html = money(item.final_line_price);
          }
          priceEl.innerHTML = html;
        }
        const spa = item.selling_plan_allocation;
        if (spa) {
          const body = node.querySelector('.gc-item__body');
          if (body) {
            const subTag = document.createElement('span');
            subTag.className = 'gc-item__sub-tag';
            subTag.innerHTML = `<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 1l4 4-4 4"/><path d="M3 11V9a4 4 0 014-4h14"/><path d="M7 23l-4-4 4-4"/><path d="M21 13v2a4 4 0 01-4 4H3"/></svg> ${esc(spa.selling_plan.name)}`;
            const actions = body.querySelector('.gc-item__actions');
            if (actions) body.insertBefore(subTag, actions); else body.appendChild(subTag);
          }
        }
        if (isQuizItem) {
          const nameLink = node.querySelector('.gc-item__name');
          if (nameLink) {
            const tag = document.createElement('span');
            tag.className = 'gc-item__quiz-tag';
            tag.textContent = 'Quiz';
            nameLink.appendChild(tag);
          }
        }
      } else {
        // Fallback for variants not pre-rendered on page load
        const img = item.image ? `<img src="${imgUrl(item.image, '200x')}" alt="${esc(item.title)}" width="100" height="100" loading="lazy">` : '';
        const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<span class="gc-item__variant">${esc(item.variant_title)}</span>` : '';
        let priceHtml;
        if (itemDiscPct > 0) {
          const discAmount = Math.round(item.final_line_price * itemDiscPct / 100);
          quizDiscountTotal += discAmount;
          const discPrice = item.final_line_price - discAmount;
          priceHtml = `<span class="gc-item__price"><s class="gc-item__price--was">${money(item.final_line_price)}</s> ${money(discPrice)}<span class="gc-item__quiz-badge">-${itemDiscPct}%</span></span>`;
        } else {
          const wasPrice = item.original_line_price > item.final_line_price
            ? `<s class="gc-item__price--was">${money(item.original_line_price)}</s> ` : '';
          priceHtml = `<span class="gc-item__price">${wasPrice}${money(item.final_line_price)}</span>`;
        }
        const quizTag = isQuizItem ? '<span class="gc-item__quiz-tag">Quiz</span>' : '';
        const spa = item.selling_plan_allocation;
        const subTag = spa ? `<span class="gc-item__sub-tag"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 1l4 4-4 4"/><path d="M3 11V9a4 4 0 014-4h14"/><path d="M7 23l-4-4 4-4"/><path d="M21 13v2a4 4 0 01-4 4H3"/></svg> ${esc(spa.selling_plan.name)}</span>` : '';
        const wrapper = document.createElement('div');
        wrapper.innerHTML = `<div class="gc-item" data-gc-item data-line="${i+1}" data-vid="${item.variant_id}"><a href="${item.url}" class="gc-item__img">${img}</a><div class="gc-item__body"><div class="gc-item__top"><a href="${item.url}" class="gc-item__name">${esc(item.product_title)}${quizTag}</a>${priceHtml}</div>${variant}${subTag}<div class="gc-item__actions"><div class="gc-qty"><button class="gc-qty__btn" data-gc-minus>−</button><span class="gc-qty__val" data-gc-qty>${item.quantity}</span><button class="gc-qty__btn" data-gc-plus>+</button></div><button class="gc-item__remove" data-gc-remove>Rimuovi</button></div></div></div>`;
        node = wrapper.firstElementChild;
      }
      // Gift lines (€0 — added by EG Auto Add / gofor360 Gifts): no qty controls,
      // no remove (the gift apps would re-add them anyway), clear "Omaggio" tag.
      if (item.final_line_price === 0 && !item.__optimistic) {
        node.classList.add('gc-item--gift');
        node.querySelectorAll('.gc-qty, [data-gc-remove], .gc-item__sub-tag').forEach(e => e.remove());
        const actions = node.querySelector('.gc-item__actions');
        const tag = document.createElement('span');
        tag.className = 'gc-item__gift-tag';
        tag.textContent = item.quantity > 1 ? `Omaggio ×${item.quantity}` : 'Omaggio';
        if (actions) actions.prepend(tag); else node.querySelector('.gc-item__body')?.appendChild(tag);
      }
      frag.appendChild(node);
    });
    el.items.innerHTML = '';
    el.items.appendChild(frag);

    // Store quiz discount for checkout and totals
    state.quizDiscount = quizDiscountTotal;
  }

  /* ── PERSONALIZED UPSELLS ── */
  async function renderUpsells(cart, total, t) {
    if (!el.upsellList || !cart.item_count) return;

    let recs = getPersonalizedRecs(cart);

    // "Ponte" verso il prossimo premio regalo (guida €60, Carlo €90, MAG5+ €150):
    // se mancano ≤ €35, metti per primo il prodotto più economico che fa superare la soglia.
    let bridgeText = '';
    if (t >= 1 && t < TOP()) {
      const nextTier = CFG.tiers[t];
      const gap = nextTier.at - total;
      if (gap > 0 && gap <= 35) {
        const pool = getPersonalizedRecs(cart, 60);
        const fits = pool.filter(r => r.price >= gap && r.price <= gap + 30)
          .sort((a, b) => (a.price - b.price) || (b.score - a.score));
        const bridge = fits[0];
        if (bridge) {
          bridge.bridge = true;
          recs = [bridge].concat(recs.filter(r => r.id !== bridge.id)).slice(0, CFG.maxUpsells);
          bridgeText = `Ti mancano €${Math.ceil(gap)} per ${nextTier.label}: aggiungi il primo e lo sblocchi`;
        }
      }
    }

    if (!recs.length) {
      el.upsell.style.display = 'none';
      return;
    }

    const hd = getUpsellHeading(cart);
    const heading = hd.heading, sub = bridgeText || hd.sub;
    const headingEl = $('.gc-upsell__heading', el.upsell);
    if (headingEl) headingEl.textContent = heading;

    let contextEl = $('.gc-upsell__context', el.upsell);
    if (sub) {
      if (!contextEl) {
        contextEl = document.createElement('p');
        contextEl.className = 'gc-upsell__context';
        headingEl.after(contextEl);
      }
      contextEl.textContent = sub;
      contextEl.classList.toggle('gc-upsell__context--bridge', !!bridgeText);
    } else if (contextEl) {
      contextEl.remove();
    }

    el.upsell.style.display = '';

    const nextAt = t < TOP() ? CFG.tiers[t].at : null;
    const tierLabels = ['spedizione gratis', 'guida in regalo', 'consiglio con Carlo', 'MAG5+ 150g gratis'];

    // AOV-style: clone pre-rendered Liquid templates by product handle.
    // Zero /products/{handle}.json fetches at runtime — all HTML is already on the page.
    const cards = recs.map(rec => {
      const tpl = document.querySelector(`[data-gc-upsell-tpl="${rec.handle}"]`);
      if (tpl && tpl.content && tpl.content.firstElementChild) {
        const node = tpl.content.firstElementChild.cloneNode(true);
        if (rec.bridge) node.classList.add('gc-upsell__card--bridge');
        // Set the badge if applicable (template emits an empty hidden badge)
        const badgeEl = node.querySelector('[data-gc-tpl-badge]');
        if (badgeEl) {
          if (nextAt && (total + rec.price) >= nextAt) {
            const tierIdx = CFG.tiers.findIndex(tier => tier.at === nextAt);
            const label = tierIdx >= 0 ? tierLabels[tierIdx] : 'offerta';
            badgeEl.textContent = `Sblocca ${label}`;
            badgeEl.hidden = false;
          } else {
            badgeEl.remove();
          }
        }
        const reasonEl = node.querySelector('[data-gc-tpl-reason]');
        if (reasonEl) {
          if (rec.reason && rec.reason.text) {
            reasonEl.textContent = rec.reason.text;
          } else {
            reasonEl.remove();
          }
        }
        return node;
      }
      return null;
    }).filter(Boolean);

    if (cards.length) {
      el.upsellList.innerHTML = '';
      const frag = document.createDocumentFragment();
      cards.forEach(c => frag.appendChild(c));
      el.upsellList.appendChild(frag);
    } else {
      el.upsell.style.display = 'none';
    }
  }

  /* ── BUNDLE UPSELL POPUP ──
     When the user clicks ATC we FIRST check if a `upsell_rule` metaobject
     targets the variant. If yes, we show a modal proposing the bundle BEFORE
     writing anything to the cart. The user then decides:
       • "Add bundle"   → POST /cart/add.js with BOTH trigger + suggested
       • "Only trigger" → POST /cart/add.js with just the trigger
     After either choice, we open the drawer as usual. This avoids the
     "add trigger, maybe add suggested" race + double POST. */
  const popupEl = document.querySelector('[data-gc-popup]');
  const popupOverlayEl = document.querySelector('[data-gc-popup-overlay]');
  const popupBodyEl = popupEl ? popupEl.querySelector('[data-gc-popup-body]') : null;

  /* ── Lazy popup templates ──
     The upsell/kit/subscription popup templates (~230 KB of HTML) are no longer
     inlined in every page: they come from sections/gc-popup-templates.liquid via
     the Section Rendering API, prefetched when the browser is idle. */
  let _gcTplPromise = null, _gcTplLoaded = false;
  function ensurePopupTemplates(timeoutMs) {
    const box = document.getElementById('gc-popup-templates');
    if (!box || !box.hasAttribute('data-gc-lazy')) { _gcTplLoaded = true; return Promise.resolve(); }
    if (!_gcTplPromise) {
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      _gcTplPromise = fetch(root + '?sections=gc-popup-templates', { credentials: 'same-origin' })
        .then(r => (r.ok ? r.json() : {}))
        .then(j => {
          const html = j && j['gc-popup-templates'];
          if (html) {
            const tmp = document.createElement('div');
            tmp.innerHTML = html;
            const src = tmp.querySelector('#gc-popup-templates-src');
            box.innerHTML = src ? src.innerHTML : '';
          }
          _gcTplLoaded = true;
        })
        .catch(() => { _gcTplPromise = null; });
    }
    if (!timeoutMs) return _gcTplPromise;
    return Promise.race([_gcTplPromise, new Promise(r => setTimeout(r, timeoutMs))]);
  }

  /* ── Popup helpers: tracking, frequency cap, A/B bucket ── */
  let _gcCurrentTrack = null;
  // GA4 measurement IDs configured on the page via gtag (e.g. G-516XMH13Q3).
  // Events go ONLY to GA4 (send_to), never to the Google Ads tag.
  function gcGa4Ids() {
    const ids = [];
    try {
      (window.dataLayer || []).forEach(e => {
        try { const a = Array.from(e); if (a[0] === 'config' && /^G-/.test(String(a[1])) && !ids.includes(a[1])) ids.push(a[1]); } catch (_) {}
      });
    } catch (_) {}
    return ids;
  }
  function gcTrack(name, data) {
    const evt = 'gc_' + name;
    const params = data || {};
    // 1) GA4 directly (no GTM configuration needed)
    try {
      const ids = gcGa4Ids();
      if (typeof window.gtag === 'function' && ids.length) window.gtag('event', evt, Object.assign({}, params, { send_to: ids }));
    } catch (e) {}
    // 2) Shopify Customer Events (custom pixels) + 3) GTM dataLayer
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(evt, params); } catch (e) {}
    try { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: evt }, params)); } catch (e) {}
  }
  function gcPopupSeen() {
    try { return JSON.parse(sessionStorage.getItem('gc_popup_seen') || '[]'); } catch (e) { return []; }
  }
  function gcPopupMarkSeen(key) {
    try { const s = gcPopupSeen(); if (!s.includes(key)) { s.push(key); sessionStorage.setItem('gc_popup_seen', JSON.stringify(s)); } } catch (e) {}
  }
  function gcPageHasOwnSubUpsell() {
    try {
      if (document.getElementById('msu-root')) return true;
      const d = Object.getOwnPropertyDescriptor(window, 'aovCartDrawerUpdateAndOpen');
      return !!(d && d.get);
    } catch (e) { return false; }
  }
  function gcAbBucket() {
    try {
      let b = localStorage.getItem('gc_ab_sub_vs_kit');
      if (b !== 'A' && b !== 'B') { b = Math.random() < 0.5 ? 'A' : 'B'; localStorage.setItem('gc_ab_sub_vs_kit', b); }
      return b;
    } catch (e) { return 'A'; }
  }

  function closeBundlePopup() {
    if (!popupEl) return;
    popupEl.classList.remove('is-active');
    popupOverlayEl && popupOverlayEl.classList.remove('is-active');
    setTimeout(() => {
      popupEl.hidden = true;
      if (popupOverlayEl) popupOverlayEl.hidden = true;
    }, 220);
  }

  /* ── IL CLUB benefit detail overlay ──
     Each of the 6 subscription benefit cards taps this shared modal instead of
     expanding inline (which would force the cart drawer to scroll). Content is
     driven by the data-key attribute; copy lives here so we don't duplicate it
     per rule in the metaobject. */
  const CLUB_BENEFIT_DETAILS = {
    protocollo: {
      title: 'Protocollo mensile su misura',
      body: 'Ogni mese ricevi un PDF di 4-6 pagine firmato da Carlo, tarato sul tuo momento: sonno, energia, digestione, menopausa. Con integratori consigliati, ricette e ritmi giornalieri per applicare tutto senza pensarci.',
      iconClass: 'gold',
      iconSvg: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="9" y1="13" x2="15" y2="13"/><line x1="9" y1="17" x2="13" y2="17"/></svg>'
    },
    carlo: {
      title: 'Carlo risponde su WhatsApp',
      body: 'Una volta al mese scrivi a Carlo, laureato in farmacia del brand, per un consiglio personale: quale integratore aggiungere, come adattare il tuo protocollo, dubbi su interazioni. Risposta in 24-48h, come una vera farmacia di fiducia.',
      iconClass: 'green',
      iconSvg: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>'
    },
    sconti: {
      title: 'Sconti in anteprima su altri prodotti',
      body: 'Ogni mese ricevi 1-2 sconti dedicati ai soli membri del Club su prodotti selezionati (mai visti dagli altri clienti). Perfetti per provare qualcosa di nuovo senza spendere di più.',
      iconClass: 'gold',
      iconSvg: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>'
    },
    prezzo: {
      title: 'Prezzo bloccato per sempre',
      body: 'Il prezzo con cui entri oggi nel Club resta lo stesso finché sei abbonato. Anche se i listini pubblici aumentano nel tempo, tu paghi sempre lo stesso — protetto dall\'inflazione.',
      iconClass: 'green',
      iconSvg: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>'
    },
    pausa: {
      title: 'Pausa quando vuoi, zero vincoli',
      body: 'Metti in pausa per un mese, salta un ordine, cambia il prodotto, cambia la frequenza (30, 60 o 90 giorni), o disdici. Tutto in due click dal tuo account. Nessuna penale, nessuna telefonata, nessun rinnovo forzato.',
      iconClass: 'gold',
      iconSvg: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></svg>'
    },
    anteprima: {
      title: 'Prodotti in anteprima',
      body: 'I nuovi prodotti gofor360 li vedi (e li puoi ordinare) 7 giorni prima di tutti gli altri clienti, con uno sconto Club dedicato al lancio. Prima gli abbonati, poi il pubblico.',
      iconClass: 'green',
      iconSvg: '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2l3 6 7 1-5 5 1 7-6-3-6 3 1-7-5-5 7-1z"/></svg>'
    }
  };
  const detailOverlayEl = document.querySelector('[data-gc-popup-detail-overlay]');
  const detailTitleEl = document.querySelector('[data-gc-popup-detail-title]');
  const detailBodyEl = document.querySelector('[data-gc-popup-detail-body]');
  const detailIconEl = document.querySelector('[data-gc-popup-detail-icon]');
  function openClubBenefitDetail(key) {
    const d = CLUB_BENEFIT_DETAILS[key];
    if (!d || !detailOverlayEl) return;
    if (detailIconEl) {
      detailIconEl.className = 'gc-popup__detail-icon gc-popup__detail-icon--' + d.iconClass;
      detailIconEl.innerHTML = d.iconSvg;
      if (d.iconClass === 'green') {
        detailIconEl.style.background = '#e8f0eb';
        detailIconEl.style.color = '#2d6a4f';
      } else {
        detailIconEl.style.background = '#fef9ec';
        detailIconEl.style.color = '#c8920d';
      }
    }
    if (detailTitleEl) detailTitleEl.textContent = d.title;
    if (detailBodyEl) detailBodyEl.textContent = d.body;
    detailOverlayEl.hidden = false;
    requestAnimationFrame(() => detailOverlayEl.classList.add('is-open'));
  }
  function closeClubBenefitDetail() {
    if (!detailOverlayEl) return;
    detailOverlayEl.classList.remove('is-open');
    setTimeout(() => { detailOverlayEl.hidden = true; }, 200);
  }
  if (detailOverlayEl) {
    const closeBtn = document.querySelector('[data-gc-popup-detail-close]');
    const okBtn = document.querySelector('[data-gc-popup-detail-ok]');
    closeBtn && closeBtn.addEventListener('click', closeClubBenefitDetail);
    okBtn && okBtn.addEventListener('click', closeClubBenefitDetail);
    detailOverlayEl.addEventListener('click', (e) => {
      if (e.target === detailOverlayEl) closeClubBenefitDetail();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && detailOverlayEl.classList.contains('is-open')) {
        closeClubBenefitDetail();
      }
    });
  }

  /**
   * If a upsell rule targets the trigger variant, show the popup.
   *
   * @param {object} opts – { triggerVid, onAccept({mode, suggestedVid, triggerVid}), onDismiss() }
   * @returns {boolean} true if the popup was shown, false if no rule matched
   */
  function showBundlePopupIfMatched(opts) {
    if (window.__GC_NO_POPUP__) return false; // pagine senza popup (es. MAG5+ Regolarita)
    if (!popupEl || !popupBodyEl) return false;
    const tpls = Array.from(document.querySelectorAll(`[data-gc-popup-tpl="${opts.triggerVid}"]`));
    if (!tpls.length) return false;

    // Frequency cap: at most one popup per trigger product per browser session.
    const triggerKey = String(opts.triggerVid);
    if (gcPopupSeen().includes(triggerKey)) return false;

    // Pick the template. If a trigger has BOTH a subscription and a kit rule, run a
    // stable 50/50 A/B split per visitor (A = abbonamento, B = kit); otherwise
    // priority subscription > kit > upsell.
    // Pages that ship their own subscription upsell (MAG5+ PDP "msu" modal) keep
    // it: never stack our subscription popup on top of theirs.
    const subOk = !gcPageHasOwnSubUpsell();
    const byMode = (m) => (m === 'subscription' && !subOk) ? null : tpls.find(t => t.getAttribute('data-mode') === m);
    let abVariant = null;
    let tpl;
    if (byMode('subscription') && byMode('kit')) {
      abVariant = gcAbBucket();
      tpl = abVariant === 'A' ? byMode('subscription') : byMode('kit');
    } else {
      tpl = byMode('subscription') || byMode('kit') || byMode('upsell') || tpls.find(t => subOk || t.getAttribute('data-mode') !== 'subscription');
    }
    if (!tpl || !tpl.content) return false;

    const suggestedVid = parseInt(tpl.getAttribute('data-suggested-vid'), 10);
    const mode = tpl.getAttribute('data-mode') || 'upsell';

    // Don't propose what the customer already has: the suggested kit/product is
    // already in the cart, or (subscription) the trigger is already on a plan.
    const items = (state.cart && state.cart.items) || [];
    if (mode === 'subscription') {
      if (items.some(i => Number(i.variant_id) === Number(opts.triggerVid) && i.selling_plan_allocation)) return false;
    } else if (items.some(i => Number(i.variant_id) === suggestedVid)) {
      return false;
    }

    popupBodyEl.innerHTML = '';
    popupBodyEl.appendChild(tpl.content.cloneNode(true));

    gcPopupMarkSeen(triggerKey);
    const trackData = { mode, ab_variant: abVariant || 'none', trigger_variant_id: triggerKey, suggested_variant_id: String(suggestedVid), trigger_title: tpl.getAttribute('data-trigger-title') || '', suggested_title: tpl.getAttribute('data-suggested-title') || '' };
    gcTrack('popup_shown', trackData);
    const origAccept = opts.onAccept, origDismiss = opts.onDismiss;
    opts = Object.assign({}, opts, {
      onAccept: (a) => { gcTrack('popup_accept', trackData); return origAccept(a); },
      onDismiss: () => { gcTrack('popup_decline', trackData); return origDismiss(); }
    });
    _gcCurrentTrack = trackData;

    // Accept: for KIT mode we replace the trigger; for UPSELL we add on top
    const ctaBtn = popupBodyEl.querySelector('[data-gc-popup-cta]');
    if (ctaBtn) {
      ctaBtn.addEventListener('click', async () => {
        if (ctaBtn.classList.contains('is-added')) return;
        ctaBtn.classList.add('is-added');
        const labelEl = ctaBtn.querySelector('.gc-popup__cta-label');
        if (labelEl) labelEl.textContent = 'Aggiunto ✓';
        closeBundlePopup();
        opts.onAccept({mode, suggestedVid, triggerVid: opts.triggerVid});
      });
    }
    // Decline: keep cart as-is (whatever the trigger added), open drawer
    const declineBtn = popupBodyEl.querySelector('[data-gc-popup-decline]');
    if (declineBtn) {
      declineBtn.addEventListener('click', () => {
        closeBundlePopup();
        opts.onDismiss();
      });
    }
    // Subscription mode: wire each benefit card to the shared detail overlay.
    // Tapping a card opens a modal on top of the popup (no cart drawer scroll).
    if (mode === 'subscription') {
      const benefitBtns = popupBodyEl.querySelectorAll('[data-gc-popup-benefit]');
      benefitBtns.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          openClubBenefitDetail(btn.getAttribute('data-key'));
          gcTrack('popup_benefit_detail', Object.assign({ benefit: btn.getAttribute('data-key') }, _gcCurrentTrack || {}));
        });
      });
    }
    // Dismiss controls: X, overlay click, ESC — attached per-instance
    const onXClick = (e) => {
      if (e.target.closest('[data-gc-popup-close]')) {
        popupEl.removeEventListener('click', onXClick);
        closeBundlePopup();
        opts.onDismiss();
      }
    };
    popupEl.addEventListener('click', onXClick);
    const onOverlayClick = () => {
      popupOverlayEl.removeEventListener('click', onOverlayClick);
      closeBundlePopup();
      opts.onDismiss();
    };
    if (popupOverlayEl) popupOverlayEl.addEventListener('click', onOverlayClick);
    const onEsc = (e) => {
      if (e.key === 'Escape' && popupEl && !popupEl.hidden) {
        document.removeEventListener('keydown', onEsc);
        closeBundlePopup();
        opts.onDismiss();
      }
    };
    document.addEventListener('keydown', onEsc);

    popupEl.hidden = false;
    if (popupOverlayEl) popupOverlayEl.hidden = false;
    requestAnimationFrame(() => {
      popupEl.classList.add('is-active');
      if (popupOverlayEl) popupOverlayEl.classList.add('is-active');
    });
    return true;
  }

  function buildAddItem(id, quantity, properties, sellingPlan) {
    const item = { id, quantity: quantity || 1, properties: properties || {} };
    if (sellingPlan) item.selling_plan = sellingPlan;
    return item;
  }

  /* ── TOAST ── */
  function toast(msg) {
    if (!el.toast) return;
    el.toast.innerHTML = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M20 6L9 17l-5-5"/></svg> ${msg}`;
    el.toast.classList.add('is-visible');
    setTimeout(() => el.toast.classList.remove('is-visible'), 3000);
  }

  /* ── CONFETTI CELEBRATION ── */
  function spawnConfetti(tierCard) {
    const canvas = document.createElement('canvas');
    canvas.className = 'gc-confetti-canvas';
    tierCard.style.position = 'relative';
    tierCard.style.overflow = 'visible';
    tierCard.appendChild(canvas);
    const ctx = canvas.getContext('2d');
    const W = canvas.width = tierCard.offsetWidth + 20;
    const H = canvas.height = tierCard.offsetHeight + 40;

    const emojis = ['🎉', '🎁', '✨', '🥳', '👏', '🎊'];
    const colors = ['#2d6a4f', '#52b788', '#95d5b2', '#f4d35e', '#ee6c4d', '#8338ec', '#ff006e'];
    const particles = [];
    const COUNT = 40;

    for (let i = 0; i < COUNT; i++) {
      const useEmoji = Math.random() < 0.3;
      particles.push({
        x: W * 0.5 + (Math.random() - 0.5) * W * 0.4,
        y: H * 0.5,
        vx: (Math.random() - 0.5) * 8,
        vy: -(Math.random() * 6 + 2),
        size: useEmoji ? 14 + Math.random() * 6 : 4 + Math.random() * 4,
        color: colors[Math.floor(Math.random() * colors.length)],
        emoji: useEmoji ? emojis[Math.floor(Math.random() * emojis.length)] : null,
        rotation: Math.random() * 360,
        rotSpeed: (Math.random() - 0.5) * 12,
        gravity: 0.12 + Math.random() * 0.08,
        opacity: 1,
        decay: 0.012 + Math.random() * 0.008,
      });
    }

    let frame = 0;
    function tick() {
      ctx.clearRect(0, 0, W, H);
      let alive = 0;
      particles.forEach(p => {
        if (p.opacity <= 0) return;
        alive++;
        p.x += p.vx;
        p.vy += p.gravity;
        p.y += p.vy;
        p.rotation += p.rotSpeed;
        p.opacity -= p.decay;
        if (p.opacity < 0) p.opacity = 0;
        ctx.save();
        ctx.globalAlpha = p.opacity;
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rotation * Math.PI / 180);
        if (p.emoji) {
          ctx.font = `${p.size}px sans-serif`;
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.fillText(p.emoji, 0, 0);
        } else {
          ctx.fillStyle = p.color;
          ctx.fillRect(-p.size / 2, -p.size / 2, p.size, p.size * 0.6);
        }
        ctx.restore();
      });
      frame++;
      if (alive > 0 && frame < 120) {
        requestAnimationFrame(tick);
      } else {
        canvas.remove();
      }
    }
    requestAnimationFrame(tick);
  }

  /* ── EVENTS ── */
  function bind() {
    overlay.addEventListener('click', close);
    $$('[data-gc-close]', drawer).forEach(b => b.addEventListener('click', close));
    CFG.cartSelectors.forEach(s => $$(s).forEach(e => { e.addEventListener('click', ev => { ev.preventDefault(); open(); }); }));
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && state.open) close(); });

    drawer.addEventListener('click', async e => {
      const tgt = e.target;

      // Qty minus
      const minus = tgt.closest('[data-gc-minus]');
      if (minus) { const r = minus.closest('[data-gc-item]'), l = +r.dataset.line, c = +$('[data-gc-qty]', r).textContent; if (c <= 1) { r.classList.add('is-removing'); setTimeout(() => api.change(l, 0), 300); } else api.change(l, c - 1); return; }

      // Qty plus
      const plus = tgt.closest('[data-gc-plus]');
      if (plus) { const r = plus.closest('[data-gc-item]'), l = +r.dataset.line, c = +$('[data-gc-qty]', r).textContent; api.change(l, c + 1); return; }

      // Remove
      const rm = tgt.closest('[data-gc-remove]');
      if (rm) { const r = rm.closest('[data-gc-item]'); r.classList.add('is-removing'); setTimeout(() => api.change(+r.dataset.line, 0), 300); return; }

      // Upsell add
      const uBtn = tgt.closest('[data-gc-upsell-add]');
      if (uBtn) { uBtn.classList.add('is-added'); uBtn.textContent = 'Aggiunto ✓'; await api.add(+uBtn.dataset.gcUpsellAdd); return; }
    });

    // INTERCEPT add-to-cart form submit in capture phase BEFORE Peak's product-form.
    // We bypass Peak's POST /cart/add.js (which Peak makes slower by attaching
    // `sections=cart-drawer,cart-icon-bubble,...` — that forces Shopify to render
    // those Liquid sections server-side, adding 200-500ms). Our minimal POST
    // (just the items) is significantly faster, and then we do a quick GET /cart.js
    // and render. Net win: ~500-700ms faster than letting Peak handle it.
    document.addEventListener('submit', async (e) => {
      const form = e.target;
      if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
      e.preventDefault();
      e.stopImmediatePropagation();

      const fd = new FormData(form);
      const id = fd.get('id');
      if (!id) return;
      const quantity = parseInt(fd.get('quantity'), 10) || 1;
      const properties = {};
      for (const [k, v] of fd.entries()) {
        const m = /^properties\[(.+)\]$/.exec(k);
        if (m && v !== '') properties[m[1]] = v;
      }
      const sellingPlan = fd.get('selling_plan');

      const submitBtn = form.querySelector('button[type="submit"], input[type="submit"]');
      if (submitBtn) submitBtn.setAttribute('aria-busy', 'true');

      const intId = parseInt(id, 10);

      // Step 1: always add the trigger to the cart first. This mirrors Ritual's
      // pattern — the user sees "X added to cart" in the popup toast because
      // the item is authoritatively in the cart already. If they close the
      // popup, the cart still contains what they clicked.
      const triggerItem = buildAddItem(intId, quantity, properties, sellingPlan);
      try {
        const r = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [triggerItem] }),
          credentials: 'same-origin'
        });
        if (!r.ok) {
          const err = await r.json().catch(() => ({}));
          toast(api._italianError(err.description || err.message || ''));
          if (submitBtn) submitBtn.removeAttribute('aria-busy');
          return;
        }
        await api.get();
        render();
      } catch (err) {
        toast('Errore di rete. Riprova.');
        if (submitBtn) submitBtn.removeAttribute('aria-busy');
        return;
      }

      // Step 2: if a matching rule exists, show the popup proposing the
      // suggested product. If accepted, we add it. If dismissed/declined, we
      // open the drawer with just the trigger.
      const openDrawerOnly = () => {
        open();
        if (submitBtn) submitBtn.removeAttribute('aria-busy');
      };

      await ensurePopupTemplates(1500);
      const popupShown = showBundlePopupIfMatched({
        triggerVid: intId,
        onAccept: (args) => {
          // Fire-and-forget the shared accept flow. It handles optimistic UI,
          // parallel POSTs and reconciliation.
          runBundleAccept(args);
          if (submitBtn) submitBtn.removeAttribute('aria-busy');
        },
        onDismiss: openDrawerOnly,
      });
      if (!popupShown) {
        // No rule → drawer opens directly with the trigger already inside
        openDrawerOnly();
      }
    }, { capture: true });
  }

  /* Optimistically merge the /cart/add.js response into state.cart so render()
     can run without another network round-trip. The next api.get() will
     reconcile any discrepancies (gifts, discounts, etc.). */
  function mergeAddedItemLocally(added, requestedQty) {
    if (!added || !state.cart) return;
    const newItem = {
      variant_id: added.variant_id || added.id,
      product_id: added.product_id,
      quantity: added.quantity || requestedQty || 1,
      title: added.title || added.product_title || '',
      product_title: added.product_title || added.title || '',
      variant_title: added.variant_title || '',
      image: added.image || added.featured_image?.url || '',
      url: added.url || '',
      price: added.price || 0,
      original_price: added.original_price || added.price || 0,
      line_price: added.line_price || (added.price * (added.quantity || 1)) || 0,
      original_line_price: added.original_line_price || added.line_price || 0,
      final_price: added.final_price || added.price || 0,
      final_line_price: added.final_line_price || added.line_price || (added.price * (added.quantity || 1)) || 0,
      properties: added.properties || {},
      selling_plan_allocation: added.selling_plan_allocation || null,
    };
    // If this variant is already in the cart, increment quantity; otherwise unshift
    const existingIdx = state.cart.items.findIndex(i => i.variant_id === newItem.variant_id);
    if (existingIdx >= 0) {
      const ex = state.cart.items[existingIdx];
      ex.quantity += newItem.quantity;
      ex.line_price += newItem.line_price;
      ex.final_line_price += newItem.final_line_price;
      ex.original_line_price += newItem.original_line_price;
    } else {
      state.cart.items.unshift(newItem);
    }
    state.cart.item_count = (state.cart.item_count || 0) + newItem.quantity;
    state.cart.total_price = (state.cart.total_price || 0) + newItem.final_line_price;
    state.cart.original_total_price = (state.cart.original_total_price || 0) + newItem.original_line_price;
  }

  /* ── PENDING SKELETON / OPTIMISTIC ITEM ──
     When the user clicks add-to-cart we paint a placeholder row that looks
     identical to a real cart item — full product image, title, price and
     quantity sniffed from the PDP. This makes the perceived add-to-cart time
     ≈ 0ms; the placeholder is silently replaced when /cart/add.js + /cart.js
     complete (~500-800ms later). A subtle shimmer overlay tells the user the
     state is still pending without making the row look broken. */
  function readPdpProductInfo(btn) {
    const out = { title: '', img: '', priceCents: 0, qty: 1, variantTitle: '' };
    if (!/^\/products\//.test(location.pathname)) return out;
    const cleanWs = s => (s || '').replace(/\s+/g, ' ').trim();
    const form = btn && (btn.closest('form[action*="/cart"]') || btn.closest('product-form'));

    // Quantity from the form
    if (form) {
      const qtyInput = form.querySelector('input[name="quantity"]');
      if (qtyInput) out.qty = parseInt(qtyInput.value, 10) || 1;
    }
    const selectedVariantId = form ? parseInt(form.querySelector('input[name="id"]')?.value, 10) : null;

    // Prefer the prefetched product JSON. It knows the exact price of the
    // selected variant; if the form's variant_id can't be matched (multi-variant
    // edge case), fall back to the first available variant — close enough for an
    // optimistic skeleton and accurate ~95% of the time.
    const product = state.pdpProduct;
    if (product) {
      out.title = product.title || '';
      let variant = null;
      if (selectedVariantId && product.variants) {
        variant = product.variants.find(v => v.id === selectedVariantId)
               || product.variants.find(v => v.available)
               || product.variants[0];
      }
      if (variant) {
        out.priceCents = variant.price; // Shopify gives prices in cents already
        if (variant.title && variant.title !== 'Default Title') out.variantTitle = variant.title;
        if (variant.featured_image?.src) out.img = variant.featured_image.src;
      }
      if (!out.img && product.featured_image) out.img = product.featured_image;
    }

    // Fallbacks for things the JSON didn't give us — pull from the DOM.
    if (!out.title) {
      const titleEl = document.querySelector('h1.product__title, .product__title, .product-title, h1[class*="title"]');
      if (titleEl) {
        out.title = cleanWs(titleEl.textContent);
        const half = Math.floor(out.title.length / 2);
        if (half > 4 && out.title.slice(0, half).trim() === out.title.slice(-half).trim()) {
          out.title = out.title.slice(0, half).trim();
        }
      }
    }
    if (!out.img) {
      const imgEl = document.querySelector('.product__media img, .product-media img, [class*="product"][class*="image"] img');
      if (imgEl) out.img = imgEl.currentSrc || imgEl.src || '';
    }
    return out;
  }

  function addPendingSkeleton(info) {
    if (!el.items) return;
    if (el.items.querySelector('.gc-item--pending')) return; // dedupe
    info = info || {};
    const title = info.title ? esc(info.title) : 'Aggiungendo al carrello…';
    const qty = info.qty || 1;
    const imgUrl = info.img ? info.img.replace(/_\d+x(\.[a-z]+)/, '_200x$1') : '';
    const imgHtml = imgUrl
      ? `<img src="${esc(imgUrl)}" alt="" width="100" height="100" loading="eager">`
      : '';
    const priceHtml = info.priceCents > 0
      ? `<span class="gc-item__price">${money(info.priceCents * qty)}</span>`
      : `<span class="gc-item__price"><span class="gc-pending-dots">···</span></span>`;
    const variantHtml = info.variantTitle
      ? `<span class="gc-item__variant">${esc(info.variantTitle)}</span>`
      : '';

    const row = document.createElement('div');
    row.className = 'gc-item gc-item--pending';
    row.innerHTML = `
      <span class="gc-item__img">${imgHtml}</span>
      <div class="gc-item__body">
        <div class="gc-item__top">
          <span class="gc-item__name">${title}</span>
          ${priceHtml}
        </div>
        ${variantHtml}
        <div class="gc-item__actions">
          <div class="gc-qty">
            <button class="gc-qty__btn" disabled>−</button>
            <span class="gc-qty__val">${qty}</span>
            <button class="gc-qty__btn" disabled>+</button>
          </div>
          <span class="gc-item__remove" style="visibility:hidden">Rimuovi</span>
        </div>
      </div>`;

    // If cart was empty, replace the empty state
    const emptyEl = el.items.querySelector('.gc-empty');
    if (emptyEl) {
      el.items.innerHTML = '';
      el.items.appendChild(row);
    } else if (el.items.firstChild) {
      el.items.insertBefore(row, el.items.firstChild);
    } else {
      el.items.appendChild(row);
    }
  }
  function clearPendingSkeleton() {
    if (!el.items) return;
    el.items.querySelectorAll('.gc-item--pending').forEach(n => n.remove());
  }

  /* ── AUTO-REFRESH: detect cart changes ──
     Strategy: NO recurring polling. Three event-driven mechanisms cover all cases:
     1. rapidTimer — short burst of polls right after user clicks an add-to-cart button
        (catches theme add-to-cart flows that don't dispatch standard events).
     2. cart:updated / ajaxCart:updated / cart:add / product:added — standard events
        fired by Peak, Klaviyo, EG Auto Add to Cart, and most third-party cart apps.
     3. deferredRecheck (in api.change/add) — re-fetches after our own mutations
        to catch gift products auto-added by external apps. */
  function startCartWatch() {
    // Detect add-to-cart button clicks → rapid poll for a few seconds.
    // Also: prime the loading skeleton immediately so the user sees instant feedback
    // while Shopify's POST /cart/add.js completes (~500-700ms).
    let rapidTimer = null;
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('button[type="submit"], input[type="submit"], [name="add"], .product-form__submit, .add-to-cart, .shopify-payment-button__button');
      if (btn && (btn.closest('form[action*="/cart/add"]') || btn.closest('form[action*="/cart"]') || btn.closest('product-form'))) {
        // Capture product info from the PDP for an OPTIMISTIC placeholder that
        // looks identical to a real line item (title + image + price + qty).
        // The user sees the product appear instantly — no perceived wait for
        // Shopify's POST /cart/add.js (~500-700ms). The placeholder gets
        // swapped for the real cart render when the POST completes.
        const pending = readPdpProductInfo(btn);
        addPendingSkeleton(pending);
        ensurePopupTemplates(); // make sure popup templates are in by the time the add completes
        // Do NOT open the drawer optimistically here — we don't yet know which
        // variant will actually be added (Peak/custom widgets may swap it) nor
        // whether a `upsell_rule` will target it and want to show its popup
        // first. neutralizeNativeDrawer.handleThemeAdd opens the drawer at
        // the right moment (after Shopify confirms the add) unless a popup
        // takes over.

        if (rapidTimer) clearInterval(rapidTimer);
        let checks = 0;
        const snapCount = state.cart?.item_count ?? 0;
        const snapTotal = state.cart?.total_price ?? 0;
        rapidTimer = setInterval(async () => {
          checks++;
          try {
            const r = await fetch('/cart.js', { credentials: 'same-origin' });
            const c = await r.json();
            if (c.item_count !== snapCount || c.total_price !== snapTotal) {
              state.cart = c;
              clearPendingSkeleton();
              render();
              clearInterval(rapidTimer); rapidTimer = null;
            } else if (checks >= 20) {
              // Give up after 20 × 200ms = 4s. Skeleton is auto-cleared by next render.
              clearPendingSkeleton();
              clearInterval(rapidTimer); rapidTimer = null;
            }
          } catch(e) { /* silent */ }
        }, 200);
      }
    });

    // Listen for custom cart events (Peak, Klaviyo, EG Auto Add, most apps)
    const onCartEvent = async () => {
      clearPendingSkeleton();
      if (!state.busy) {
        const prevCount = state.cart?.item_count ?? 0;
        await api.get();
        render();
        // Don't reveal the drawer if a popup is about to appear — handleThemeAdd
        // will call open() at the right time after the popup closes.
        if (state.cart.item_count > prevCount && !_suppressOpen) open();
      }
    };
    document.addEventListener('cart:updated', onCartEvent);
    document.addEventListener('ajaxCart:updated', onCartEvent);
    document.addEventListener('cart:add', onCartEvent);
    document.addEventListener('product:added', onCartEvent);
  }

  /* ── QUIZ CTA ──
     The actual quiz lives at /pages/quiz-v2. The drawer only renders a CTA card
     that redirects there. The previous embedded-quiz implementation
     (~280 lines of QUIZ_QUESTIONS + initQuiz body) was removed as dead code. */
  function initQuiz() {
    function goToQuiz() { window.location.href = '/pages/quiz-v2'; }
    $$('[data-gc-quiz-open]').forEach(b => b.addEventListener('click', goToQuiz));
    const ctaDiv = $('[data-gc-quiz-cta]');
    if (ctaDiv) ctaDiv.addEventListener('click', e => {
      if (!e.target.closest('[data-gc-quiz-open]')) goToQuiz();
    });
  }

  /* ── NEUTRALIZE NATIVE THEME CART DRAWER ── */
  /**
   * When the theme (or a custom widget) triggers a native add-to-cart via
   * `<cart-drawer>` / `<cart-notification>`, Peak calls `renderContents(state)`
   * with the response of POST /cart/add.js. That's our real hook point — the
   * capture-phase submit listener doesn't fire for programmatic fetches or for
   * bespoke widgets that don't dispatch a form submit event.
   *
   * Here we:
   *   1) refresh our own state from /cart.js
   *   2) if a `upsell_rule` popup template targets the just-added variant,
   *      show it INSTEAD of opening the drawer immediately
   *   3) otherwise open the drawer as before
   */
  // When set, the neutralized nativeDrawer.open() becomes a no-op so Peak's
  // internal flow can't reveal our drawer for a split second before the popup
  // slides in on top.
  let _suppressOpen = false;

  async function removeLineByVariantId(variantId, requireNoPlan = false) {
    // Always fetch fresh from server — state.cart may have been optimistically
    // mutated (e.g. by the kit-accept flow) before we get here.
    // requireNoPlan=true: only match a line WITHOUT a selling_plan_allocation.
    // Used for subscription mode where we need to remove the one-time trigger
    // line but keep the just-added subscription line for the same variant.
    const c = await fetch('/cart.js', {credentials:'same-origin'}).then(r => r.json());
    const idx = c.items.findIndex(i =>
      Number(i.variant_id) === Number(variantId)
      && (!requireNoPlan || !i.selling_plan_allocation)
    );
    if (idx < 0) return;
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({line: idx + 1, quantity: 0}),
      credentials: 'same-origin'
    });
  }

  /**
   * Shared "accept bundle popup" flow.
   *
   * Mutates state.cart optimistically (add kit, remove trigger if mode==='kit'),
   * renders, opens the drawer immediately, then fires the real network POSTs in
   * parallel. Reconciles silently at the end. Rolls back on failure.
   *
   * Used by BOTH the submit-intercept flow (bind()) and the theme-native flow
   * (neutralizeNativeDrawer.handleThemeAdd). Extracted so both callers share the
   * same signature (`{mode, suggestedVid, triggerVid}`) — the old
   * `acceptSuggested(suggestedVid)` positional signature had been silently
   * receiving the whole args object as the variant id, producing 400 responses
   * from Shopify.
   */
  async function runBundleAccept({mode, suggestedVid, triggerVid}) {
    const snapshot = state.cart ? JSON.parse(JSON.stringify(state.cart)) : null;

    // Read suggested product data straight from the popup template attributes
    // (server-rendered from the Shopify metaobject). This is the authoritative
    // source — the older `data-gc-line-tpl` lookup missed products (like kits)
    // that fall outside the reco map, producing zero-priced "ghost" line items.
    // Look the template up by TRIGGER + MODE. Looking it up by suggested-vid alone
    // picked the wrong rule when another rule suggests the same product (e.g. the
    // "Magnesio → MAG5+" upsell vs the "MAG5+ → Club" subscription) → no selling plan.
    const popupTpl = document.querySelector(`[data-gc-popup-tpl="${triggerVid}"][data-mode="${mode}"]`)
      || document.querySelector(`[data-gc-popup-tpl][data-suggested-vid="${suggestedVid}"]`);
    const suggestedTitle = popupTpl?.getAttribute('data-suggested-title') || '';
    const suggestedImage = popupTpl?.getAttribute('data-suggested-image') || '';
    const suggestedUrl = popupTpl?.getAttribute('data-suggested-url') || '/';
    const suggestedProductId = parseInt(popupTpl?.getAttribute('data-suggested-product-id') || '0', 10);
    const suggestedPriceCents = parseInt(popupTpl?.getAttribute('data-suggested-price-cents') || '0', 10);
    const suggestedWasCents = parseInt(popupTpl?.getAttribute('data-suggested-was-cents') || '0', 10);
    const suggestedComparePrice = suggestedWasCents > 0 ? suggestedWasCents : suggestedPriceCents;
    // For subscription mode we need the selling plan id — the template emits the
    // trigger's own 60-day plan id so the add.js call binds the plan on Shopify.
    const sellingPlanIdRaw = popupTpl?.getAttribute('data-selling-plan-id') || '';
    const sellingPlanId = sellingPlanIdRaw && sellingPlanIdRaw.includes('/')
      ? sellingPlanIdRaw.split('/').pop() : sellingPlanIdRaw;

    if (state.cart) {
      const optimisticItem = {
        variant_id: suggestedVid,
        product_id: suggestedProductId,
        quantity: 1,
        title: suggestedTitle,
        product_title: suggestedTitle,
        variant_title: '',
        image: suggestedImage,
        url: suggestedUrl,
        price: suggestedPriceCents,
        original_price: suggestedComparePrice,
        line_price: suggestedPriceCents,
        original_line_price: suggestedComparePrice,
        final_price: suggestedPriceCents,
        final_line_price: suggestedPriceCents,
        properties: {},
        selling_plan_allocation: null,
        __optimistic: true,
      };
      if (mode === 'kit' || mode === 'subscription') {
        // Replace the one-time trigger with the kit (mode=kit) or the same
        // trigger re-added on a subscription plan (mode=subscription).
        const removed = state.cart.items.find(i => Number(i.variant_id) === Number(triggerVid));
        state.cart.items = state.cart.items.filter(i => Number(i.variant_id) !== Number(triggerVid));
        if (removed) {
          state.cart.item_count -= removed.quantity;
          state.cart.total_price -= removed.final_line_price;
          state.cart.original_total_price -= removed.original_line_price;
        }
        state.cart.items.unshift(optimisticItem);
        state.cart.item_count += 1;
        state.cart.total_price += suggestedPriceCents;
        state.cart.original_total_price += suggestedPriceCents;
      } else {
        state.cart.items.unshift(optimisticItem);
        state.cart.item_count += 1;
        state.cart.total_price += suggestedPriceCents;
        state.cart.original_total_price += suggestedPriceCents;
      }
      render();
    }
    _suppressOpen = false;
    open();

    // Fire real POSTs SERIALLY (not in parallel). Serializing prevents a race
    // where Shopify's /cart/change.js reads the cart before /cart/add.js has
    // added the kit — the change would then use a stale line index and either
    // remove the wrong line or fail to remove the trigger, leaving the trigger
    // in the cart alongside the kit.
    //
    // The user never sees this latency because the drawer is already open with
    // the optimistic cart. Only the silent reconcile at the end is slower.
    // SAFETY RULE: the product the customer added is NEVER removed unless the
    // replacement (kit / subscription) has been confirmed by Shopify.
    (async () => {
      const failAndResync = async (msg) => {
        toast(msg);
        try { await api.get(); } catch (_) { if (snapshot) state.cart = snapshot; }
        render();
      };
      try {
        if (mode === 'subscription') {
          // Convert the existing one-time line IN PLACE (keeps the quantity):
          // /cart/change.js with selling_plan. Atomic — no remove + re-add.
          const c0 = await fetch('/cart.js', {credentials: 'same-origin'}).then(r => r.json());
          const line = c0.items.find(i => Number(i.variant_id) === Number(triggerVid) && !i.selling_plan_allocation);
          if (!line || !sellingPlanId) { await failAndResync('Abbonamento non disponibile per questo prodotto'); return; }
          const r = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({id: line.key, quantity: line.quantity, selling_plan: Number(sellingPlanId)}),
            credentials: 'same-origin'
          });
          if (!r.ok) { await failAndResync('Abbonamento non disponibile, riprova'); return; }
        } else {
          const r = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({items: [buildAddItem(suggestedVid, 1, {}, null)]}),
            credentials: 'same-origin'
          });
          if (!r.ok) {
            // e.g. kit sold out → keep the original product, tell the customer.
            await failAndResync(mode === 'kit' ? 'Il kit non è disponibile: abbiamo tenuto il tuo prodotto' : 'Prodotto non disponibile');
            return;
          }
          if (mode === 'kit') {
            await removeLineByVariantId(triggerVid, true);
          }
        }
        const c = await api.get();
        if (state.cart && c) render();
        api.deferredRecheck();
      } catch (e) {
        await failAndResync('Errore aggiornando il carrello');
      }
    })();
  }

  /* Custom advertorial PDPs (Cistoril, Kit Sonno, MAG5+…) add via their own
     fetch('/cart/add.js') and then call cart-drawer.open() / aovCartDrawer*().
     They never pass through renderContents, so we find the just-added product
     by diffing the cart against the last snapshot and run the popup from here. */
  let _popupBaseline = null;
  let _themeAddInFlight = false;
  let _openCheckBusy = false;
  function gcSnapshot(cart) {
    const m = new Map();
    ((cart && cart.items) || []).forEach((it) => {
      if (it.final_line_price > 0) { const k = String(it.variant_id); m.set(k, (m.get(k) || 0) + it.quantity); }
    });
    return m;
  }
  async function openWithPopupCheck() {
    if (_openCheckBusy) return;
    _openCheckBusy = true;
    try {
      await Promise.all([api.get(), ensurePopupTemplates(1500)]);
      render();
      const base = _popupBaseline;
      const now = gcSnapshot(state.cart);
      _popupBaseline = now;
      let vid = null;
      if (base && !gcPageHasOwnSubUpsell()) {
        for (const it of (state.cart.items || [])) {
          const k = String(it.variant_id);
          if (it.final_line_price > 0 && (now.get(k) || 0) > (base.get(k) || 0) && document.querySelector(`[data-gc-popup-tpl="${k}"]`)) { vid = k; break; }
        }
      }
      if (vid) {
        const shown = showBundlePopupIfMatched({
          triggerVid: parseInt(vid, 10),
          onAccept: runBundleAccept,
          onDismiss: () => { _suppressOpen = false; open(); },
        });
        if (shown) return;
      }
      _suppressOpen = false;
      open();
    } catch (e) {
      _suppressOpen = false;
      open();
    } finally {
      _openCheckBusy = false;
    }
  }

  function neutralizeNativeDrawer() {
    const handleThemeAdd = (parsedState) => {
      let addedVid = parsedState?.id;
      if (!addedVid && Array.isArray(parsedState?.items) && parsedState.items[0]) {
        addedVid = parsedState.items[0].variant_id || parsedState.items[0].id;
      }

      // Popup gate — check synchronously (before any await) so we can suppress
      // the drawer flash: if a popup will be shown, block native open() calls
      // Peak may make during the rest of this render cycle.
      // Templates are lazy-loaded: if they aren't there yet, hold the drawer
      // closed until we know whether a popup applies (max 1.5s).
      const tplsReady = _gcTplLoaded;
      let tpl = tplsReady && addedVid && document.querySelector(`[data-gc-popup-tpl="${addedVid}"]`);
      if (tpl || (!tplsReady && addedVid)) _suppressOpen = true;

      Promise.all([api.get(), tplsReady ? null : ensurePopupTemplates(1500)]).then(() => {
        _themeAddInFlight = false;
        _popupBaseline = gcSnapshot(state.cart);
        render();
        tpl = addedVid && document.querySelector(`[data-gc-popup-tpl="${addedVid}"]`);
        if (!tpl) {
          _suppressOpen = false;
          open();
          return;
        }
        const shown = showBundlePopupIfMatched({
          triggerVid: parseInt(addedVid, 10),
          onAccept: runBundleAccept,
          onDismiss: () => {
            _suppressOpen = false;
            open();
          },
        });
        if (!shown) {
          _suppressOpen = false;
          open();
        }
      });
    };

    try {
      const nativeDrawer = document.querySelector('cart-drawer');
      if (nativeDrawer) {
        if (typeof nativeDrawer.renderContents === 'function') {
          const origRender = nativeDrawer.renderContents.bind(nativeDrawer);
          nativeDrawer.renderContents = function(parsedState) {
            _themeAddInFlight = true;
            setTimeout(() => { _themeAddInFlight = false; }, 4000);
            try { origRender(parsedState); } catch(e) {}
            handleThemeAdd(parsedState);
          };
        }
        try {
          if (typeof nativeDrawer.open === 'function') {
            // Third-party scripts (custom PDPs, msu modal) call cart-drawer.open()
            // after adding via fetch: resync, run the popup check, then open.
            // During a theme add, handleThemeAdd owns the opening.
            nativeDrawer.open = () => { if (!_suppressOpen && !_themeAddInFlight) openWithPopupCheck(); };
          } else {
            Object.defineProperty(nativeDrawer, 'open', {
              get() { return state.open; },
              set(val) { if (val && !_suppressOpen) open(); },
              configurable: true
            });
          }
        } catch(e) {}
      }

      const nativeNotif = document.querySelector('cart-notification');
      if (nativeNotif) {
        if (typeof nativeNotif.renderContents === 'function') {
          const origNotifRender = nativeNotif.renderContents.bind(nativeNotif);
          nativeNotif.renderContents = function(parsedState) {
            _themeAddInFlight = true;
            setTimeout(() => { _themeAddInFlight = false; }, 4000);
            try { origNotifRender(parsedState); } catch(e) {}
            handleThemeAdd(parsedState);
          };
        }
        try {
          if (typeof nativeNotif.open === 'function') {
            nativeNotif.open = () => { open(); api.get().then(() => render()); };
          }
        } catch(e) {}
      }
    } catch(e) {
      console.warn('[GoforCart] neutralizeNativeDrawer error (non-fatal):', e);
    }

    // AOV compatibility shims. Live PDP scripts (mag5-bundle, msu modal, …) were
    // written for the AOV app and call window.aovCartDrawer*(). With AOV off we
    // answer those calls. Assigning (not defineProperty) keeps any wrapper getter
    // installed by the msu modal working: its setter stores our function as the
    // "real" drawer. Never overrides a real AOV function if the app is present.
    try {
      const refreshAndOpen = () => { if (!_themeAddInFlight) openWithPopupCheck(); };
      const shims = {
        aovCartDrawerUpdateAndOpen: refreshAndOpen,
        aovCartDrawerOpen: refreshAndOpen,
        aovCartDrawerUpdate: () => api.get().then(() => render()),
        aovCartDrawerClose: () => { if (state.open) close(); },
      };
      Object.keys(shims).forEach((k) => {
        if (typeof window[k] !== 'function') window[k] = shims[k];
      });
      document.addEventListener('cart:refresh', () => api.get().then(() => render()));
    } catch(e) {
      console.warn('[GoforCart] AOV shim error (non-fatal):', e);
    }
  }

  /* ── SUBSCRIBE & SAVE ── */
  function initSubscribe() {
    state.sellingPlanMap = loadSellingPlanMap();
    state.subscribeActive = false;
    const subscribeEl = $('[data-gc-subscribe]', drawer);
    const input = $('[data-gc-subscribe-input]', drawer);
    if (!subscribeEl || !input) return;

    input.addEventListener('change', async () => {
      state.subscribeActive = input.checked;
      subscribeEl.toggleAttribute('data-active', input.checked);
      if (state.busy) return;
      state.busy = true;
      drawer.classList.add('is-loading');
      try {
        const cart = state.cart;
        // Only touch items that HAVE a selling plan — leave free gifts, kits, promos untouched
        const subscribableItems = [];
        const linesToRemove = [];
        cart.items.forEach((item, i) => {
          const planId = state.sellingPlanMap[String(item.variant_id)];
          if (planId && item.final_line_price > 0) {
            subscribableItems.push({
              id: item.variant_id,
              quantity: item.quantity,
              properties: item.properties || {},
              planId: planId
            });
            linesToRemove.push(i + 1); // Shopify lines are 1-indexed
          }
        });

        if (subscribableItems.length === 0) {
          // Nothing to change
          state.busy = false;
          drawer.classList.remove('is-loading');
          return;
        }

        // Remove subscribable items (highest line first to avoid index shift)
        for (const line of linesToRemove.reverse()) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line, quantity: 0 }),
            credentials: 'same-origin'
          });
        }

        // Re-add them with or without selling_plan
        const newItems = subscribableItems.map(item => {
          const entry = { id: item.id, quantity: item.quantity, properties: item.properties };
          if (input.checked) {
            entry.selling_plan = item.planId;
          }
          return entry;
        });
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: newItems }),
          credentials: 'same-origin'
        });
        await api.get();
        render();
      } catch (e) {
        console.error('Subscribe toggle error:', e);
      } finally {
        state.busy = false;
        drawer.classList.remove('is-loading');
      }
    });
  }

  function updateSubscribeVisibility() {
    const subscribeEl = $('[data-gc-subscribe]', drawer);
    if (!subscribeEl) return;
    const cart = state.cart;
    if (!cart || cart.item_count === 0) {
      subscribeEl.style.display = 'none';
      return;
    }
    // Hide if ALL items are kits (no selling plan available)
    if (!state.sellingPlanMap) { subscribeEl.style.display = 'none'; return; }
    const subscribable = cart.items.filter(item => !!state.sellingPlanMap[String(item.variant_id)] && !isGiftLine(item));
    const hasSubscribable = subscribable.length > 0;
    subscribeEl.style.display = hasSubscribable ? '' : 'none';
    // Reflect the real cart state: toggle ON when every subscribable line is already on a plan.
    const input = $('[data-gc-subscribe-input]', subscribeEl);
    const allOnPlan = hasSubscribable && subscribable.every(i => !!i.selling_plan_allocation);
    if (input && !state.busy) {
      input.checked = allOnPlan;
      state.subscribeActive = allOnPlan;
      subscribeEl.toggleAttribute('data-active', allOnPlan);
    }
    // Savings in euro on THIS cart (−20% on the lines not yet on a plan).
    const saveEl = $('[data-gc-sub-save]', subscribeEl);
    if (saveEl) {
      const cents = subscribable.filter(i => !i.selling_plan_allocation)
        .reduce((sum, i) => sum + Math.round(i.final_line_price * CFG.clubDiscountPct / 100), 0);
      if (cents > 0 && !allOnPlan) {
        saveEl.textContent = `Abbonati e risparmi ${money(cents)}`;
      } else if (allOnPlan) {
        saveEl.textContent = 'Abbonamento attivo · −20% ogni mese';
      } else {
        saveEl.textContent = `Abbonati e risparmia il ${CFG.clubDiscountPct}%`;
      }
      saveEl.hidden = false;
    }
    // EG "Sub gift": Multivitamine only with a MAG 5+ / MAG 5+ Regolarità subscription.
    const giftNote = $('[data-gc-sub-gift]', subscribeEl);
    if (giftNote) giftNote.hidden = !cart.items.some(i => CFG.subGiftVariants.includes(Number(i.variant_id)));
  }

  /* ── PDP PRODUCT PREFETCH ──
     When the user lands on a /products/* page, prefetch the product JSON so we
     can render an accurate optimistic line item (with correct price for the
     selected variant) the instant they click add-to-cart. The fetch runs in
     parallel with the rest of init and is non-blocking. */
  function prefetchPdpProduct() {
    if (!/^\/products\//.test(location.pathname)) return;
    const handle = location.pathname.split('/products/')[1].split('/')[0].split('?')[0];
    if (!handle) return;
    state.pdpProduct = null;
    fetch(`/products/${handle}.js`, { credentials: 'same-origin' })
      .then(r => r.ok ? r.json() : null)
      .then(p => { if (p) state.pdpProduct = p; })
      .catch(() => {});
  }

  /* ── INIT ── */
  async function init() {
    try { state.recoMap = loadRecoMap(); } catch(e) { console.warn('[GoforCart] loadRecoMap error:', e); }
    try { neutralizeNativeDrawer(); } catch(e) { console.warn('[GoforCart] neutralize error:', e); }
    // Prefetch popup templates when the browser is idle (off the critical path).
    try {
      const prefetchTpls = () => ensurePopupTemplates();
      if ('requestIdleCallback' in window) requestIdleCallback(prefetchTpls, { timeout: 3000 });
      else setTimeout(prefetchTpls, 1500);
    } catch (e) {}
    try { prefetchPdpProduct(); } catch(e) { /* non-fatal */ }

    const cart = await api.get();
    state.prevTier = tierOf(cart);
    _popupBaseline = gcSnapshot(cart);

    // Load selling plan map BEFORE first render (updateSubscribeVisibility needs it)
    try { state.sellingPlanMap = loadSellingPlanMap(); } catch(e) { state.sellingPlanMap = {}; }

    try { render(); } catch(e) { console.warn('[GoforCart] render error:', e); }

    // These MUST run regardless of render errors
    try { bind(); } catch(e) { console.warn('[GoforCart] bind error:', e); }
    try { startCartWatch(); } catch(e) { console.warn('[GoforCart] startCartWatch error:', e); }
    try { initQuiz(); } catch(e) { console.warn('[GoforCart] initQuiz error:', e); }
    try { initSubscribe(); } catch(e) { console.warn('[GoforCart] initSubscribe error:', e); }
    // Warm the upsell product cache in the background — first drawer open will
    // hit cache instead of waiting on 4 parallel /products/{handle}.json fetches.
    setTimeout(() => { try { prefetchTopUpsells(); } catch(e) {} }, 800);

    window.GoforCart = { open, close, toggle: () => state.open ? close() : open(), refresh: async () => { await api.get(); render(); }, add: api.add };
  }

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
